import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap, List, fromJS } from 'immutable';
const baseUrl = 'knowledge-content/v1/knowledge-articles';
const baseUrlV3 = 'knowledge-content/v2/knowledge-article';
const filterPublished = articles => articles.filter(a => a.currentState === 'PUBLISHED');
const formatResponse = response => {
  // @ts-expect-error ts-migrate FIXME some props don't exist
  const {
    objects,
    offset,
    count,
    total,
    hasMore
  } = response;
  return ImmutableMap({
    hasMore: hasMore || false,
    offset: offset || 0,
    count: count || objects.length,
    total: total || objects.length,
    results: List(filterPublished(objects)).map(article => fromJS(article))
  });
};
export const defaultApiWrapper = (apiClient, knowledgeBaseVersion, kbId) => ({
  fetchRenderedContent({
    id,
    version: kbVersion
  }) {
    return kbVersion === '3' ? getArticleV3(apiClient, id) : getArticle(apiClient, id);
  },
  async searchArticles({
    count,
    offset,
    query
  }) {
    if (kbId) {
      const kbIds = Array.isArray(kbId) ? kbId : [kbId];
      const response = knowledgeBaseVersion === '3' ? await getArticlesV3({
        apiClient,
        count,
        kbIds,
        offset,
        query
      }) : await getArticles(apiClient, count, offset, query, kbIds[0]);
      return formatResponse(response);
    }
    const [combinedKBs, response, responseV3] = await Promise.all([getCombinedKBs(apiClient), getArticles(apiClient, count, offset, query), getArticlesV3({
      apiClient,
      count,
      offset,
      query
    })]);

    // Produce a set of all KB IDs, including translations
    const allKbIds = new Set([...combinedKBs.legacyKnowledgeBases.map(kb => kb.id), ...combinedKBs.scpKnowledgeBases.flatMap(kb => [kb.values.hs_id, ...Object.values(kb.translations).map(t => t.values.hs_id)])]);
    return formatResponse({
      objects: [...response.objects.filter(a => allKbIds.has(a.contentGroupId)), ...responseV3.objects.filter(a => allKbIds.has(a.contentGroupId))],
      limit: count,
      offset,
      total: response.total + responseV3.total,
      totalCount: response.totalCount + responseV3.totalCount
    });
  }
});
export const searchArticles = ({
  count,
  offset,
  query
}) => {
  return http.get(baseUrl, {
    query: {
      limit: count,
      offset,
      name__icontains: query,
      order: '-updated',
      state__eq: 'PUBLISHED',
      archived: false
    }
  }).then(formatResponse);
};
async function getArticle(apiClient, id) {
  const results = await apiClient.get(baseUrl, {
    query: {
      id
    }
  });
  const article = results.objects[0];
  const {
    absoluteUrl,
    title
  } = article;
  return {
    body: title,
    htmlBody: `<a href=${absoluteUrl}>${title}</p>`
  };
}
async function getArticleV3(apiClient, id) {
  const {
    values: article
  } = await apiClient.get(`${baseUrlV3}/${id}`);
  return {
    body: article.hs_name,
    htmlBody: `<a href=${article.hs_absolute_url}>${article.hs_name}</p>`
  };
}
async function getArticles(apiClient, count, offset, query, kbId) {
  const response = await apiClient.get(baseUrl, {
    query: Object.assign({
      limit: count,
      offset,
      name__icontains: query,
      order: '-updated',
      state__eq: 'PUBLISHED',
      archived: false
    }, kbId ? {
      contentGroupId: kbId
    } : {})
  });
  const normalizedObjects = response.objects.map(a => Object.assign({}, a, {
    version: '2'
  }));
  return {
    limit: response.limit,
    offset: response.offset,
    total: response.total,
    totalCount: response.totalCount,
    objects: normalizedObjects
  };
}
async function getArticlesV3({
  apiClient,
  count,
  kbIds,
  offset,
  query
}) {
  const response = await apiClient.get(baseUrlV3, {
    query: Object.assign({
      hs_archived_in_dashboard__eq: 0,
      hs_name__icontains: query,
      hs_published_at__gt: 0,
      limit: count,
      offset,
      order: '-hs_updated_at'
    }, kbIds && kbIds.length > 0 ? {
      hs_group_id__in: kbIds
    } : {})
  });
  const mapped = [];
  response.results.forEach(({
    values: article
  }) => {
    mapped.push({
      currentState: article.hs_state,
      contentGroupId: article.hs_group_id,
      id: article.hs_id,
      title: article.hs_name,
      version: '3',
      language: article.hs_language,
      absoluteUrl: article.hs_absolute_url,
      articleSummary: article.hs_summary
    });
  });
  if (query || !(kbIds && kbIds.length > 0)) {
    response.results.forEach(({
      values: article,
      translations
    }) => {
      if (translations) {
        Object.values(translations).forEach(({
          values: translationArticle
        }) => {
          if (translationArticle.hs_state === 'PUBLISHED') {
            mapped.push({
              currentState: translationArticle.hs_state,
              contentGroupId: translationArticle.hs_group_id,
              id: translationArticle.hs_id,
              title: translationArticle.hs_name,
              version: '3',
              language: translationArticle.hs_language,
              absoluteUrl: translationArticle.hs_absolute_url,
              articleSummary: translationArticle.hs_summary,
              isTranslation: true,
              originalArticleId: article.hs_id
            });
          }
        });
      }
    });
  }
  const seen = new Set();
  const deduplicated = mapped.filter(article => {
    if (seen.has(article.id)) return false;
    seen.add(article.id);
    return true;
  });
  return {
    limit: count,
    offset,
    total: response.total,
    totalCount: response.total,
    objects: deduplicated
  };
}
function getCombinedKBs(apiClient) {
  return apiClient.get('knowledge-content/v2/migration/combined');
}